import { Injectable, HostListener } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { changedObject } from '@mmortgage/dynamic-form';
import { BehaviorSubject } from "rxjs";

@Injectable()
export class FrameworkUtilityComponent {

    private forScrollObj = {
        currScrYpos: 0,
        targScrYpos: 0,
        speed: 50,
        reducePos: 0
    };
    private formCompArray: Array<any>;
    private scrollTimmerId: any;
    private hasViewRefreshed: boolean;
    subPropeObj: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    constructor() {
    }

    InitValues() {
        try {
            this.forScrollObj.currScrYpos = 0;
            this.forScrollObj.targScrYpos = 0;
            this.hasViewRefreshed = false;
            this.formCompArray = new Array<any>();
            this.subPropeObj.next(this.formCompArray.length);
        } catch (e) {
        }
    }


    onSmoothScrollStart() {
        try {
            window.scrollTo(0, this.forScrollObj.currScrYpos);
            this.forScrollObj.currScrYpos -= this.forScrollObj.reducePos;
            this.scrollTimmerId = setTimeout(() => {
                if (this.forScrollObj.currScrYpos > this.forScrollObj.targScrYpos) {
                    this.onSmoothScrollStart();
                } else {
                    this.forScrollObj.currScrYpos = this.forScrollObj.targScrYpos;
                    this.onSmoothScrollStart();
                    clearTimeout(this.scrollTimmerId);
                }
            }, 10);
        } catch (e) {
        }
    }

    removeViewFromArr(view: string) {
        try {
            let indx = this.formCompArray.
                findIndex(curObj => curObj.currFormName === view);
            if (indx > -1) {
                this.formCompArray.splice(indx, 1);
            }
        } catch (e) {
        }
    }

    resetFormModels_DeleteFromArray_ForGivenView(view: string) {
        try {
            let Obj = this.getFormCompObjForFormName(view);
            if (Obj) {
                Obj.frameWorkScope.resetModelValuesToEmpty();
                this.removeViewFromArr(view);
            }
        } catch (e) {
        }
    }

    makeField_enable_disabled(view: string, disabled: boolean, fieldNames: Array<string>) {
        try {
            let Obj = this.getFormCompObjForFormName(view);
        } catch (e) {
        }
    }

    updateFormCompArr(obj: any) {
        try {
            let indx = this.formCompArray.
                findIndex(curObj => curObj.currFormName === obj.currFormName);
            if (indx > -1) {
                this.hasViewRefreshed = true;
                this.formCompArray.splice(indx, 1, obj);
            } else {
                this.formCompArray.push(obj);
            }
            this.subPropeObj.next(this.formCompArray.length);
            return this.formCompArray;
        } catch (e) {
        }
    }

    getInvalidForm() {
        try {
            let findObj = this.formCompArray.find(obj => obj.currFormGroup.valid === false && obj.currFormGroup.status !== 'DISABLED');
            return findObj;
        } catch (e) {
        }
    }

    getFormCompArray() {
        try {
            return this.formCompArray;
        } catch (e) {
        }
    }

    getFormCompObjForFormName(nameStr: string) {
        try {
            return this.formCompArray.find(formArrObj => formArrObj.currFormName === nameStr);
        } catch (e) {
        }
    }

    refreshAllViews(inpObj: any = null) {
        try {
            this.formCompArray.forEach(obj => {
                obj.frameWorkScope.onViewRefresh(inpObj);
            });
        } catch (e) {
        }
    }

    refreshGivenViews(viewNames: string[], inpObj: any = null) {
        try {
            viewNames.forEach(element => {
                let formObj = this.getFormCompObjForFormName(element);
                if (formObj) {
                    formObj.frameWorkScope.onViewRefresh(inpObj);
                }
            });
        } catch (e) {
        }
    }

    updateValueToGivenViews(viewNames: string[], inpObj: any = null) {
        try {
            viewNames.forEach(element => {
                let formObj = this.getFormCompObjForFormName(element);
                if (formObj) {
                    formObj.frameWorkScope.updateValuesToFormGrp(inpObj);
                }
            });
        } catch (e) {
        }
    }


    refreshGivenViewsOnDemand(viewNames: string[], inpObj: any = null) {
        try {
            viewNames.forEach(element => {
                let formObj = this.getFormCompObjForFormName(element);
                if (formObj) {
                    formObj.frameWorkScope.refreshOnDemand(formObj.currFormGroup, inpObj);
                }
            });
        } catch (e) {
        }
    }

    checkIsFormFieldsAreValidForGivenViews(viewNames: string[]) {
        try {
            let fieldsAreValid: boolean;
            fieldsAreValid = true;
            viewNames.forEach(element => {
                let formObj = this.getFormCompObjForFormName(element);
                if (formObj) {
                    if (fieldsAreValid) {
                        fieldsAreValid = this.findErrorFieldInGivenForm(formObj, false);
                    }
                    this.makeFormFieldAsTouchedForGivenFormGrp(formObj);
                }
            });
            return fieldsAreValid;
        } catch (e) {
        }
    }

    findErrorFieldInGivenForm(inValidFormObj: any, allFieldToTouched: boolean) {
        try {
            let fieldsAreValid: boolean;
            fieldsAreValid = true;
            let errFromGrp: FormControl = inValidFormObj.currFormGroup.controls;
            for (let k in errFromGrp) {
                if (!errFromGrp[k].valid && !errFromGrp[k].disabled) {
                    let tempFromcon: any = errFromGrp[k];
                    // When childElement Has error.
                    if (tempFromcon.controls) {
                        let childEleObj = tempFromcon.controls;
                        for (let k1 in childEleObj) {
                            if (!childEleObj[k1].valid && !childEleObj[k1].disabled) {
                                k = k1; break;
                            }
                        }
                    }
                    fieldsAreValid = false;
                    if (allFieldToTouched) {
                        this.makeFormFieldAsTouched();
                    }
                    this.forScrollObj.currScrYpos = window.pageYOffset;
                    document.getElementById(k).focus();
                    this.setValueForScrollAndStart();
                    break;
                }
            }
            return fieldsAreValid;
        } catch (e) {
        }
    }
 

    makeFromFieldToUntouched() {
        try {
            if (this.formCompArray) {
                this.formCompArray.forEach(obj => {
                    let tempCurrFormGrp: FormGroup = obj.currFormGroup;
                    tempCurrFormGrp.markAsUntouched();
                })
            }
        } catch (e) {
        }
    }

    makeFromFieldToDirty() {
        try {
            if (this.formCompArray) {
                this.formCompArray.forEach(obj => {
                    let tempCurrFormGrp: FormGroup = obj.currFormGroup;
                    tempCurrFormGrp.markAsDirty();
                })
            }
        } catch (e) {
        }
    }

    makeFormFieldAsTouchedForGivenFormGrp(formObj) {
        try {
            let tempCurrFormContr: FormControl = formObj.currFormGroup.controls;
            for (let controlObj in tempCurrFormContr) {
                if (!tempCurrFormContr[controlObj].valid && !tempCurrFormContr[controlObj].disabled) {
                    let tempFromcon: any = tempCurrFormContr[controlObj];
                    if (tempFromcon.controls) {
                        let childEleObj: any = tempFromcon.controls;
                        for (let k1 in childEleObj) {
                            if (!childEleObj[k1].valid) {
                                let tempChildFromcon: FormGroup = childEleObj[k1];
                                tempChildFromcon.markAsTouched();
                            }
                        }
                    }
                    tempFromcon.markAsTouched();
                }
            }
        } catch (e) {
        }
    }

    makeFormFieldAsTouched() {
        try {
            if (this.formCompArray) {
                this.formCompArray.forEach(obj => {
                    this.makeFormFieldAsTouchedForGivenFormGrp(obj)
                })
            }
        } catch (e) {
        }
    }

    setValueForScrollAndStart() {
        try {
            this.forScrollObj.targScrYpos = window.pageYOffset;
            let totDis = this.forScrollObj.currScrYpos - this.forScrollObj.targScrYpos;
            let movStep = totDis / this.forScrollObj.speed;
            this.forScrollObj.reducePos = movStep;
            this.onSmoothScrollStart();
        } catch (e) {
        }
    }

    udpateModelForThisView(obj: any) {
        try {
            if (obj.isFrameWorkForm) {
                obj.frameWorkScope.updateModelToDataFromOutside(obj.currFormGroup);
            }
        } catch (e) {
        }
    }

    updateFrameWorkModelsOnlyForThisViews(viewNames: string[]) {
        try {
            viewNames.forEach(element => {
                let formObj = this.getFormCompObjForFormName(element);
                if (formObj) {
                    if (formObj.isFrameWorkForm) {
                        formObj.frameWorkScope.updateModelToDataFromOutside(formObj.currFormGroup);
                    }
                }
            });

        } catch (e) {
        }
    }

    updateFrameWorkModelsWithValue() {
        try {
            if (this.formCompArray) {
                this.formCompArray.forEach(obj => {
                    this.udpateModelForThisView(obj);
                });
            }
        } catch (e) {
        }
    }


    getIsViewRefreshedFlag() {
        try {
            return this.hasViewRefreshed;
        } catch (e) {
        }
    }

    setViewRefreshedFlag(bol) {
        try {
            this.hasViewRefreshed = bol;
        } catch (e) {
        }
    }

    checkIsFieldsValid(viewName: string = "", models: Array<string> = new Array<string>()): boolean {
        let fieldsAreValid: boolean = true;
        let frmGrp = this.formCompArray.filter(obj => (obj.currFormName === viewName));
        if (frmGrp.length > 0 && fieldsAreValid) {
            let frameWrokGrp = frmGrp[0].frameWorkScope;
            fieldsAreValid = frameWrokGrp.checkIsFieldsAreValid(models);
        }
        return fieldsAreValid;
    }


    //// ******* This Below 'setFormComponentArr' & 'checkIsRequiredErrorExists' need to check 
    setFormComponentArr(formGroupArray: any) {
        this.formCompArray = formGroupArray;
    }
    checkIsRequiredErrorExists() {
        try {
            let isRequiredErrorExists = false;
            let invalidForm = this.formCompArray.filter(obj => obj.currFormGroup.valid === false);
            for (let index = 0; index < invalidForm.length; index++) {
                let keys = Object.keys(invalidForm[index].currFormGroup.controls);
                for (let ctrlIndx = 0; ctrlIndx < keys.length; ctrlIndx++) {
                    let ctrlName = keys[ctrlIndx];
                    let formControl = invalidForm[index].currFormGroup.controls[ctrlName];
                    if (!formControl.controls) {
                        if (formControl.errors && (formControl.errors.required || formControl.errors.email)) {
                            isRequiredErrorExists = true;
                            break;
                        }
                    } else {
                        let childkeys = Object.keys(formControl.controls);
                        childkeys.forEach(keyName => {
                            if (formControl.controls[keyName].errors && (formControl.controls[keyName].errors.required || formControl.controls[keyName].errors.invalidPhoneNumberValidator)) {
                                isRequiredErrorExists = true;
                            }
                        });
                        if (isRequiredErrorExists) {
                            break;
                        }
                    }
                }
                if (isRequiredErrorExists) {
                    break;
                }
            }
            return isRequiredErrorExists;
        } catch (e) {
        }
    }
    //*****************************    END *********************************** */



    ///************ UPDATED FOR NEW TAB ISSUE AND DISPLAY RULE RENDERING */
    /// CURRENTLY I AM HOLDING THIS METHOD NOT TO WORK
    renderFormsWithNewInputData(changedOBj: Array<changedObject>, inputData: any, viewNames: Array<string> = new Array<string>()) {
        try {
            

        } catch (e) {
            console.error('ERROR @ "renderFormsWithNewInputData" funtion')
        }
    }
    refreshFieldsByName(viewNames: Array<string> = new Array<string>(), inpData: any = null, models: Array<string> = new Array<string>()) {
        try {
            if (viewNames.length === 0) {
                if (this.formCompArray) {
                    this.formCompArray.forEach(obj => {
                        obj.frameWorkScope.refreshFieldsByName(inpData, models);
                    });
                }
            } else if (viewNames.length > 0) {
                viewNames.forEach(element => {
                    let formObj = this.getFormCompObjForFormName(element);
                    if (formObj) {
                        formObj.frameWorkScope.refreshFieldsByName(inpData, models);
                    }
                });
            }
        } catch (e) {
            console.error('ERROR @ "refreshFieldsByName" funtion')
        }
    }



    checkIsFormFieldsAreValid(displayValidationMsg: boolean = true) {
        try {
            let allFieldToTouched: boolean = true;
            let inValidFormObj = this.getInvalidForm();
            let fieldsAreValid: boolean;
            fieldsAreValid = true;
            if (inValidFormObj && displayValidationMsg) {
                fieldsAreValid = this.findErrorFieldInGivenForm(inValidFormObj, allFieldToTouched);
                return fieldsAreValid;
            } else {
                return inValidFormObj ? false : true;
            }
        } catch (e) {
        }
    }

    displayErrors() {
        for (let i in this.formCompArray) {
            try {
                let fieldsAreValid: boolean;
                fieldsAreValid = true;
                let inValidFormObj = this.formCompArray[i];
                let errFromGrp: FormControl = inValidFormObj.currFormGroup.controls;
                for (let k in errFromGrp) {
                    if (errFromGrp[k].touched && !errFromGrp[k].valid && !errFromGrp[k].disabled) {
                        let tempFromcon: any = errFromGrp[k];
                        // When childElement Has error.
                        let hasChildren: boolean = false;
                        if (tempFromcon.controls) {
                            hasChildren = true;
                            let childEleObj = tempFromcon.controls;
                            for (let k1 in childEleObj) {
                                if (childEleObj[k1].touched && !childEleObj[k1].valid && !childEleObj[k1].disabled) {
                                    childEleObj[k1].markAsTouched()
                                }
                            }
                        }
                        fieldsAreValid = false;
                        if (!hasChildren) {
                            errFromGrp[k].markAsTouched();
                        }
                        this.forScrollObj.currScrYpos = window.pageYOffset;
                        this.setValueForScrollAndStart();
                    }
                }
                return fieldsAreValid;
            } catch (e) {
            }
        }
    }

    //******************************************************************** */
}
